import React from 'react';
import { clsx } from 'clsx';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  fullWidth?: boolean;
}

const Input: React.FC<InputProps> = ({
  label,
  error,
  fullWidth = true,
  className = '',
  id,
  ...props
}) => {
  const inputClasses = clsx(
    'block px-4 py-3 rounded-lg border transition duration-150 ease-in-out',
    'bg-white dark:bg-gray-800',
    'text-gray-900 dark:text-white',
    'placeholder-gray-500 dark:placeholder-gray-400',
    'border-gray-300 dark:border-gray-600',
    'focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent',
    fullWidth ? 'w-full' : '',
    error ? 'border-red-500 dark:border-red-500' : '',
    className
  );

  return (
    <div className="space-y-2">
      {label && (
        <label
          htmlFor={id}
          className="block text-sm font-medium text-gray-700 dark:text-gray-300"
        >
          {label}
        </label>
      )}
      <input
        id={id}
        className={inputClasses}
        {...props}
      />
      {error && (
        <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
      )}
    </div>
  );
};

export default Input;